export default class PaqueteTodoFacilController {
    constructor() {
      this.error = 0;
      this.status = 1;
      this.message = "Éxito";
      this.messageMostrar = 0;
      this.messageSistema = "";
      this.values = null;
    }


    //documentar codigo 
    /**
     * Metodo para establecer el error 1 y status 0
     * @param {*} tcMessage el mensaje de error
     * @param {*} tcMessageSistema el mensaje de error del sistema
     * @returns {void}
     */
    setError(tcMessage, tcMessageSistema = "") {
      this.error = 1;
      this.status = 0;
      this.message = tcMessage;
      this.messageMostrar = 0;
      this.messageSistema = tcMessageSistema;
    }
    
  }
  